export const ADD_LICENSE_PURCHASE_PROPERTY= "ADD_LICENSE_PURCHASE_PROPERTY";
export const GET_LICENSE_PURCHASE_PROPERTIES="GET_LICENSE_PURCHASE_PROPERTIES";
export const LICENSE_PURCHASE_PROPERTIES="LICENSE_PURCHASE_PROPERTIES";
export const DELETE_LICENSE_PURCHASE_PROPERTIY='DELETE_LICENSE_PURCHASE_PROPERTIY';
export const UPDATE_LICENSE_PURCHASE_PROPERTIY = 'UPDATE_LICENSE_PURCHASE_PROPERTIY';
export const LICENSE_PURCHASE_PROPERTIES_MESSAGE='LICENSE_PURCHASE_PROPERTIES_MESSAGE';
export const SET_ADD_EDIT = 'SET_ADD_EDIT';
export const SHOW_LOADING='SHOW_LOADING';
export const HIDE_LOADING="HIDE_LOADING";
export const ADD_LICENSE_PRICING= "ADD_LICENSE_PRICING";
export const GET_LICENSE_PRCING_LIST="GET_LICENSE_PRCING_LIST";
export const LICENSE_PRICING_LIST="LICENSE_PRICING_LIST";
export const DELETE_LICENSE_PRICING='DELETE_LICENSE_PRICING';
export const UPDATE_LICENSE_PRICING = 'UPDATE_LICENSE_PRICING';
export const ADD_LICENSE_PRICING_VALUE= "ADD_LICENSE_PRICING_VALUE";
export const GET_LICENSE_PRCING_VALUE_LIST="GET_LICENSE_PRCING_VALUE_LIST";
export const LICENSE_PRICING_VALUE_LIST="LICENSE_PRICING_VALUE_LIST";
export const DELETE_LICENSE_PRICING_VALUE='DELETE_LICENSE_PRICING_VALUE';
export const UPDATE_LICENSE_PRICING_VALUE = 'UPDATE_LICENSE_PRICING_VALUE';
export const LICENSE_PRICE_BACK='LICENSE_PRICE_BACK';
export const GET_LICENSE_PRCING_VALUE_LISTS="GET_LICENSE_PRCING_VALUE_LISTS";
